/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import 'jrs-ui/src/util/webpackPublicPathSetup';
const importStartup = import('jrs-ui/src/util/mainPagesStartup')
const importMain = () => import('jrs-ui/src/system/systemError.common');
const importCommonModule = () => import('../commons/commons.main')

importStartup.then(({default: startup}) => startup({importCommonModule})).then(importMain)